import React from "react";
import ShipPage from "./Shipmap"; // adjust path

const VessalControl = () => {
  return <ShipPage />;
}

export default VessalControl;